export function toTitleCase(value: string): string {
    return value
        .toLocaleLowerCase('pt-BR')
        .replace(
            /(^|[\s/_-])(\p{L})/gu,
            (_, sep: string, char: string) => sep + char.toLocaleUpperCase('pt-BR'),
        );
}
